import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { LogOut, MonitorSmartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const fmt = new Intl.DateTimeFormat("en-US", { timeZone: "America/Nassau", month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
const d = (v) => fmt.format(new Date(v));

export function SignedInDevices() {
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.get("/auth/sessions").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const out = async (id) => {
    try { await api.delete(`/auth/sessions/${id}`); toast.success("Device signed out"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const others = async () => {
    try {
      const { data } = await api.post("/auth/sessions/sign-out-others");
      toast.success(`Signed out ${data.signed_out} other ${data.signed_out === 1 ? "device" : "devices"}`);
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="surface p-5 sm:p-6 mb-6 fade-up" data-testid="signed-in-devices">
      <h2 className="font-heading text-lg font-semibold flex items-center gap-2"><MonitorSmartphone className="h-5 w-5" />Signed-in devices</h2>
      <ul className="mt-3 divide-y divide-border" data-testid="signed-in-devices-list">
        {items?.map((s) => (
          <li key={s.id} className="py-3 flex flex-wrap items-start gap-x-3 gap-y-2" data-testid={`session-${s.id}`}>
            <div className="min-w-0 flex-1 text-sm">
              <div className="font-semibold break-words">{s.device}
                {s.current && <span className="ml-2 rounded-full bg-emerald-100 text-emerald-800 px-2 py-0.5 text-[11px] font-semibold" data-testid="session-this-device">This device</span>}
              </div>
              <div className="text-xs text-muted-foreground mt-0.5">First signed in {d(s.created_at)} · Last active {d(s.last_active)}</div>
              <div className="text-xs text-muted-foreground">Expires {d(s.expires_at)}{s.persistent ? " (stay logged in)" : ""}</div>
            </div>
            {!s.current && (
              <Button size="sm" variant="outline" className="h-9 rounded-lg" onClick={() => out(s.id)} data-testid={`session-sign-out-${s.id}`}><LogOut className="h-3.5 w-3.5 mr-1" />Sign out</Button>
            )}
          </li>
        ))}
      </ul>
      {items?.length > 1 && (
        <Button variant="outline" onClick={others} className="mt-3 h-11 rounded-xl w-full sm:w-auto" data-testid="sign-out-others-button">Sign out all other devices</Button>
      )}
    </section>
  );
}
